import type React from 'react';
import { useEffect, useRef, useState } from 'react';

import * as styles from './styles';

export interface SidebarGroupProps {
  children: React.ReactNode;
}

export const SidebarGroup: React.FC<SidebarGroupProps> = ({ children }) => {
  const parentRef = useRef<HTMLDivElement>(null);

  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if all children elements have been rendered
    if (parentRef.current && !parentRef.current.children.length) {
      setIsVisible(false);
    }
  }, [parentRef]);

  if (!isVisible) return null;
  return (
    <div className={styles.sidebarGroup} ref={parentRef}>
      {children}
    </div>
  );
};
